"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFormReset;

var _react = require("react");

var _Contexts = require("./Contexts");

function useFormReset() {
  const {
    actions,
    resets
  } = (0, _Contexts.useFormContext)(_Contexts.BITS.actions | _Contexts.BITS.resets);
  const handleReset = (0, _react.useCallback)(() => {
    if (!actions) {
      if (process.env.NODE_ENV !== 'production') return console.error('A Form submit event ' + 'was triggered from a component outside the context of a Form. ' + 'The Button should be wrapped in a Form component');
    }

    actions.onReset();
  }, [actions]);
  return [handleReset, (0, _react.useMemo)(() => ({
    resets
  }), [resets])];
}